import React from 'react';

interface Props {
  onMerge?: () => void;
}

const EventMergeButtonTw: React.FC<Props> = ({ onMerge }) => {
  return (
    <button
      type="button"
      className="flex-1 py-2 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
      onClick={onMerge}
    >
      Merge
    </button>
  );
};

export default EventMergeButtonTw;
